/* eslint-disable react/destructuring-assignment */
import Icon from '../Icon';

const EmptyProfile = (props) => (
  <Icon {...props}>
    <path
      d="M19.1992 13.9999C19.1992 17.8659 16.0652 20.9999 12.1992 20.9999C8.33323 20.9999 5.19922 17.8659 5.19922 13.9999V13.5765C5.19922 13.2581 5.45736 12.9999 5.77579 12.9999H18.6226C18.9411 12.9999 19.1992 13.2581 19.1992 13.5765V13.9999Z"
      fill={props.color}
    />
    <path
      d="M16.1992 8C16.1992 10.2091 14.4084 12 12.1992 12C9.99008 12 8.19922 10.2091 8.19922 8C8.19922 5.79086 9.99008 4 12.1992 4C14.4084 4 16.1992 5.79086 16.1992 8Z"
      fill={props.color}
    />
    <path
      d="M20.1992 6V2"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M18.1992 4L22.1992 4"
      stroke={props.color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export default EmptyProfile;
